import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormSelect = _resolveComponent("FormSelect");
    const _component_FormCheckBox = _resolveComponent("FormCheckBox");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createVNode(_component_FormWrapper, {
            cls: "border-0",
            label: _ctx.textToUse
        }, {
            default: _withCtx(() => [
                _createVNode(_component_FormSelect, {
                    modelValue: _ctx.selectionMode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectionMode) = $event)),
                    options: _ctx.selectionOptions,
                    id: _ctx.tag + '-molecule-selection'
                }, null, 8, ["modelValue", "options", "id"]),
                (_ctx.val.considerProteins &&
                    _ctx.val.allowUserToToggleIncludeMetalsAsProtein)
                    ? (_openBlock(), _createBlock(_component_FormCheckBox, {
                        key: 0,
                        modelValue: _ctx.val.includeMetalsAsProtein,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.val.includeMetalsAsProtein) = $event)),
                        text: "Count metals/ions as part of the protein receptor",
                        id: _ctx.tag + '-include-metals'
                    }, null, 8, ["modelValue", "id"]))
                    : _createCommentVNode("", true),
                (_ctx.val.considerProteins &&
                    _ctx.val.allowUserToToggleIncludeSolventAsProtein)
                    ? (_openBlock(), _createBlock(_component_FormCheckBox, {
                        key: 1,
                        modelValue: _ctx.val.includeSolventAsProtein,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.val.includeSolventAsProtein) = $event)),
                        text: "Count solvent as part of the protein receptor",
                        id: _ctx.tag + '-include-solvent'
                    }, null, 8, ["modelValue", "id"]))
                    : _createCommentVNode("", true),
                (_ctx.val.considerProteins &&
                    _ctx.val.allowUserToToggleIncludeNucleicAsProtein)
                    ? (_openBlock(), _createBlock(_component_FormCheckBox, {
                        key: 2,
                        modelValue: _ctx.val.includeNucleicAsProtein,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.val.includeNucleicAsProtein) = $event)),
                        text: "Count nucleic acids as part of the protein receptor",
                        id: _ctx.tag + '-include-nucleic'
                    }, null, 8, ["modelValue", "id"]))
                    : _createCommentVNode("", true),
                (_ctx.val.considerProteins &&
                    _ctx.val.considerCompounds &&
                    _ctx.val.allowUserToToggleIncludeProteinAssociatedCompoundsAsProtein)
                    ? (_openBlock(), _createBlock(_component_FormCheckBox, {
                        key: 3,
                        modelValue: _ctx.val.includeProteinAssociatedCompoundsAsProtein,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.val.includeProteinAssociatedCompoundsAsProtein) = $event)),
                        text: "Count protein-associated compounds (e.g., cofactors) as part of the protein receptor",
                        id: _ctx.tag + '-include-prot-assoc-cmpds'
                    }, null, 8, ["modelValue", "id"]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["label"]),
        _createVNode(_component_FormElementDescription, { description: _ctx.summary }, null, 8, ["description"])
    ]));
}
